var body = document.getElementById('page');
document.dispatchEvent(fully_load_event);
body.classList.add('js-loaded');

var running = false;

var registrationForm = document.getElementById('registration-form');
registrationForm.onsubmit = function(e){
	e.preventDefault();
	if(running) {
		return false;
	}
	running = true;
	var form = this;
	spinForm();
	setTimeout(function(){
		var response = postFormAsync(form);
		if(response.error) {
			ga('send', 'event', 'send', 'error', 'form');
			alert(response.msg);
			stopSpinForm();
			running = false;
		} else {
			ga('send', 'event', 'send', 'success', 'form');
			alert('Probíhá vytváření účtu', 'success');
			setTimeout(function () {
				window.location.href = response.signLink;
			}, 500);
			ga('send', 'event', 'registration', 'click');
		}
	}, 500);
	return false;
};

function postFormAsync(form) {
	var req = new XMLHttpRequest();
	req.overrideMimeType('application/json');
	try {
		req.open('POST', form.action, false);
	} catch(err) {
		alert(err);
	}

	var formData = new FormData();
	var inputs = document.getElementsByTagName('input');
	for(var i=0; i < inputs.length; i++) {
		formData.append(inputs[i].name, inputs[i].value);
	}
	req.send(formData); // param string only used for POST

	if (req.readyState === 4) { // only if req is "loaded"
		if (req.status === 200) {
			return JSON.parse(req.responseText);
		} else {
			if(typeof req.responseText !== 'undefined') {
				return JSON.parse(req.responseText);
			}
			ga('send', 'event', 'send', 'error', 'form');
			return req.responseText;
		}
	}
}

function alert(msg, type) {
	type = typeof type === 'undefined' ? 'danger' : type;
	var alert = document.getElementsByClassName('alert')[0];
	alert.classList.remove('alert-success');
	alert.classList.remove('alert-danger');
	alert.classList.add('alert-' + type);

	alert.innerHTML = msg;
	alert.classList.remove('d-none');
}

function spinForm() {
	var spinner = document.getElementsByClassName('form-loaded-spinner')[0];
	spinner.classList.remove('d-none');
}

function stopSpinForm() {
	var spinner = document.getElementsByClassName('form-loaded-spinner')[0];
	spinner.classList.add('d-none');
}